import { render, staticRenderFns } from "./Bouquet.vue?vue&type=template&id=affb1210&scoped=true&"
import script from "./Bouquet.vue?vue&type=script&lang=js&"
export * from "./Bouquet.vue?vue&type=script&lang=js&"
import style0 from "./Bouquet.vue?vue&type=style&index=0&id=affb1210&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "affb1210",
  null
  
)

export default component.exports